var exports = {
  "z3": "error__C3ie2O",
  "ik": "errorIcon__26V2Gy",
  "GI": "errorHeader__P5jCSm",
};

module.exports = exports;
